import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { SectionCard } from '../common/SectionCard';
import { GradeScale } from './useGradeScale';
import { ChartType, ChartTypeToggle, TrendChart } from './chartKit';
import { SeriesChips, TrendTable } from './AnalysisParts';
import { TrendRow, TrendSeries } from './trend';

/** The trend chart (legend chips filter it) and the score table beneath it. */
const TrendSections: React.FC<{ rows: TrendRow[]; series: TrendSeries[]; grades: GradeScale }> = ({ rows, series, grades }) => {
  const [chartType, setChartType] = useState<ChartType>('line');
  const [selected, setSelected] = useState<string[]>([]);
  // A choice from another class or student whose subjects differ is ignored, not kept as an empty chart.
  const shown = useMemo(() => selected.filter((id) => series.some((s) => s.id === id)), [selected, series]);
  const visible = useMemo(() => (shown.length ? series.filter((s) => shown.includes(s.id)) : series), [series, shown]);

  return (
    <>
      <SectionCard
        title={rows.length > 1 ? 'Across exams' : rows[0]?.examName}
        action={rows.length > 1 ? <ChartTypeToggle value={chartType} onChange={setChartType} /> : undefined}
        sx={{ mb: 2.5 }}
      >
        {rows.length > 1 && (
          <Box sx={{ mb: 2 }}>
            <SeriesChips series={series} selected={shown} onChange={setSelected} />
          </Box>
        )}
        <TrendChart rows={rows} series={visible} type={chartType} grades={grades} />
      </SectionCard>

      <SectionCard title="Exam by exam">
        <TrendTable rows={rows} series={series} grades={grades} />
      </SectionCard>
    </>
  );
};

export default TrendSections;
